export default __webpack_public_path__ + "static/avoid_cheating_img-15736137abe618d9e4f21e60ec383f6f.png";